import { useAppDispatch, useAppSelector, ThunkEffects } from '@innowise-group/core';
import { useCallback } from 'react';
import { clearPreoffersItemsAction } from './preoffers.action';
import { searchAllPreoffersThunk, updateCandidatePreofferInfoThunk } from './preoffers.thunk';
import { getPreoffersItemsState } from './preoffers.selectors';
import { LocalizedPreoffersItemsState } from './preoffers.types';

export const usePreoffersItemsState = (): LocalizedPreoffersItemsState => useAppSelector(getPreoffersItemsState);

export const usePreoffersAPI = () => {
  const dispatch = useAppDispatch();
  const { isLoading, items: preoffers, ids: preoffersIds, totalPages, totalElements } = usePreoffersItemsState();

  const searchAllPreoffers = useCallback(
    (data: Parameters<typeof searchAllPreoffersThunk>[0]) => {
      return ThunkEffects.takeLatest(dispatch(searchAllPreoffersThunk(data)), searchAllPreoffersThunk.typePrefix);
    },
    [dispatch],
  );

  const updateCandidatePreofferInfo = useCallback(
    (args: Parameters<typeof updateCandidatePreofferInfoThunk>[0]) => {
      return dispatch(updateCandidatePreofferInfoThunk(args));
    },
    [dispatch],
  );

  const clearPreoffersItems = useCallback(() => {
    dispatch(clearPreoffersItemsAction());
  }, [dispatch]);

  return {
    isLoading,
    preoffers,
    preoffersIds,
    totalPages,
    totalElements,
    clearPreoffersItems,
    searchAllPreoffers,
    updateCandidatePreofferInfo,
  };
};
